export default {"src":"/_next/static/image/public/images/ic_no_clinic.67c2589bbc43cd922be9570f3a7bd03e.svg","height":128,"width":113};